import { useState } from "react";
import { motion } from "framer-motion";
import { Maximize2 } from "lucide-react";
import { GALLERY } from "@/data/content";
import Lightbox from "@/components/site/Lightbox";

export default function Gallery() {
  const [openIndex, setOpenIndex] = useState(null);
  const total = GALLERY.length;

  const next = () => setOpenIndex((i) => (i + 1) % total);
  const prev = () => setOpenIndex((i) => (i - 1 + total) % total);

  return (
    <section
      id="gallery"
      className="bg-paper py-24 md:py-32"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#16a34a]">
              Project Gallery
            </div>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#1c1917] mt-2 tracking-tight max-w-2xl">
              From the field.{" "}
              <span className="text-[#57534e]">Real properties we&rsquo;ve transformed.</span>
            </h2>
          </div>
          <div className="text-sm text-[#57534e] font-semibold">
            Tap any photo to view full size
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {GALLERY.map((img, i) => (
            <motion.button
              key={img.src}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.55, delay: i * 0.04 }}
              whileHover={{ y: -4 }}
              onClick={() => setOpenIndex(i)}
              type="button"
              data-testid={`gallery-item-${i}`}
              className="relative aspect-square rounded-3xl overflow-hidden border border-[#e7e5df] bg-[#0f1d12] group cursor-zoom-in text-left"
            >
              <img
                src={img.src}
                alt={img.alt}
                className="absolute inset-0 w-full h-full object-contain group-hover:scale-[1.04] transition-transform duration-500"
                loading="lazy"
              />
              {/* Zoom indicator */}
              <div className="absolute top-3 right-3 h-9 w-9 rounded-full bg-black/55 backdrop-blur text-white inline-flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
                <Maximize2 className="w-4 h-4" />
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <Lightbox
        items={GALLERY}
        index={openIndex}
        onClose={() => setOpenIndex(null)}
        onPrev={prev}
        onNext={next}
      />
    </section>
  );
}
